/*=========================================================================================
  File Name: moduletypologyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	createSessionsApi({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/auth/sessions/api", payload)
				.then((response) => {
					commit("ADD_SESSION", Object.assign(payload, {...response.data}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getSessionsApi({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/auth/sessions/api")
				.then((res) => {
					//commit("SET_TIPOLOGIES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					console.error(err);
				});
		});
	},
	getSessionsApiByCompany({commit}, companyId) {
		return new Promise((resolve, reject) => {
			Api.get("/auth/sessions/api/0/" + companyId)
				.then((res) => {
					commit("SET_SESSIONS", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					commit("SET_SESSIONS", []);
					console.error(err);
				});
		});
	},
	getSessionApiByToken({commit}, accessToken) {
		return new Promise((resolve, reject) => {
			Api.get(`/auth/sessions/api/${accessToken}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
					console.error(err);
				});
		});
	},
	updateSessionApi({commit}, session) {
		return new Promise((resolve, reject) => {
			const {expire_token} = session;
			Api.put(`/auth/sessions/api/${session.access_token}`, {expire_token})
				.then((response) => {
					commit("UPDATE_SESSION", Object.assign(session, {expire_token}));
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeSessionApi({commit}, accessToken) {
		return new Promise((resolve, reject) => {
			Api.delete(`/auth/sessions/api/${accessToken}`)
				.then((response) => {
					commit("REMOVE_SESSION", accessToken);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
